'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlIncludeTemplate", function ($animate) {
  return {
    restrict: 'EA',
    transclude: "element",
    terminal: true,
    priority: 400,
    controller: angular.noop,
    link: function link($scope, $element, $attrs, ctrl, $transclude) {
      var srcExp = $attrs.tlIncludeTemplate || $attrs.src;
      var currentElement = null;
      var currentScope = null;
      var cleanupLastIncludeContent = function cleanupLastIncludeContent() {
        if (currentElement) {
          currentElement.remove();
          currentElement = null;
        }
        if (currentScope) {
          currentScope.$destroy();
          currentScope = null;
        }
      };
      $scope.$watch(srcExp, function (template) {
        if (template) {
          var newScope = $scope.$new();
          ctrl.template = template;
          var clone = $transclude(newScope, function (clone) {
            cleanupLastIncludeContent();
            $animate.enter(clone, null, $element);
          });
          currentScope = newScope;
          currentElement = clone;
        } else {
          cleanupLastIncludeContent();
          ctrl.template = null;
        }
      });
    }
  };
});
ngModule.directive("tlIncludeTemplate", function ($compile) {
  return {
    restrict: 'ECA',
    priority: -400,
    require: 'tlIncludeTemplate',
    link: function link(scope, $element, $attr, ctrl) {
      $element.html(ctrl.template);
      $compile($element.contents())(scope);
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/tl/tl-include-template.js
// module id = 2896
// module chunks = 13